
import React from 'react';
import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { TableEmptyState } from "@/components/admin/games/list/TableEmptyState";
import { UserTableRow } from "./UserTableRow";
import { UserProfile } from "@/hooks/useUsersAdmin";

interface UsersTableProps {
  users: UserProfile[];
  searchTerm: string;
  onEdit: (user: UserProfile) => void;
  onChangeRole: (userId: string, newRole: string) => void;
  setSearchTerm: (term: string) => void;
  onCommissionUpdated?: () => void;
}

export const UsersTable: React.FC<UsersTableProps> = ({ 
  users, 
  searchTerm, 
  onEdit, 
  onChangeRole,
  setSearchTerm
}) => {
  if (users.length === 0) {
    return (
      <div className="rounded-md border border-[#222A35] bg-[#181D24]">
        <Table>
          <TableHeader>
            <TableRow className="border-b border-[#222A35] hover:bg-transparent">
              <TableHead className="text-[#00B6F0]">Usuário</TableHead>
              <TableHead className="text-[#00B6F0]">Jogo Preferido</TableHead>
              <TableHead className="text-[#00B6F0]">Função</TableHead>
              <TableHead className="text-[#00B6F0]">Criado em</TableHead>
              <TableHead className="text-right text-[#00B6F0]">Ações</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            <TableEmptyState
              title="Nenhum usuário encontrado"
              description={searchTerm ? "Tente ajustar seu filtro de busca." : "Não há usuários registrados no sistema."}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
            />
          </TableBody>
        </Table>
      </div>
    );
  }

  return (
    <div className="rounded-md border border-[#222A35] bg-[#181D24]">
      <Table>
        <TableHeader>
          <TableRow className="border-b border-[#222A35] hover:bg-transparent">
            <TableHead className="text-[#00B6F0]">Usuário</TableHead>
            <TableHead className="text-[#00B6F0]">Jogo Preferido</TableHead>
            <TableHead className="text-[#00B6F0]">Função</TableHead>
            <TableHead className="text-[#00B6F0]">Criado em</TableHead>
            <TableHead className="text-right text-[#00B6F0]">Ações</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {users.map((user) => (
            <UserTableRow
              key={user.id}
              user={user}
              onEdit={onEdit}
              onChangeRole={onChangeRole}
            />
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
